function client(endpoint, { body, ...customConfig } = {}) {
  const token = window.localStorage.getItem("__hayat_accesstoken__");
  const headers = { "content-type": "application/json" };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const config = {
    method: body ? "POST" : "GET",
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };
  if (body) {
    config.body = JSON.stringify(body);
  }

  return window
    .fetch(`${process.env.REACT_APP_API_URL}/${endpoint}`, config)
    .then(async (r) => {
      let data;
      try {
        data = await r.json();
      } catch {}
      if (r.ok) {
        return data;
      } else {
        return Promise.reject(data);
      }
    });
}

export default client;
